import { toast } from "react-toastify";
const handleCopy = (text: string) => {
	navigator.clipboard.writeText(text);
	toast.success("Copied to clipboard");
};

const formatNumber = (num: number | string) => {
	if (num === "-") return "-";
	return num.toString().replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export const getInitials = (input: string): string => {
	const words = input.trim().split(/\s+/);
	if (words.length === 0) {
		return "";
	}
	const firstWordInitial = words[0].charAt(0).toUpperCase();
	const secondWordInitial = words.length > 1 ? words[1].charAt(0).toUpperCase() : "";
	return firstWordInitial + secondWordInitial;
};

export function formatDate(date?: Date | string): string {
	const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric", year: "numeric" };
	return date ? new Date(date)?.toLocaleDateString("en-US", options) : "/";
}

function getOrdinalPosition(num: number): string {
	if (num === 0) {
		return "";
	}
	const suffixes = ["th", "st", "nd", "rd"];
	const value = num % 100;
	return num + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]);
}

function formatTime(dateString: string): string {
	const date = new Date(dateString);

	let hours = date.getUTCHours();
	const minutes = date.getUTCMinutes();

	const ampm = hours >= 12 ? "PM" : "AM";

	hours = hours % 12;
	hours = hours ? hours : 12;

	const formattedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();

	return `${hours}:${formattedMinutes}${ampm}`;
}

function convertToString(inputNum: string): string {
	let num = parseFloat(inputNum);
	const roundedNum = Math.round(num * 100) / 100;
	return roundedNum.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

function isGuid(value: any): boolean {
    // Regular expression to match both normalized GUIDs (without dashes) and standard GUIDs (with dashes)
    const guidPattern = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i;
    return typeof value === 'string' && guidPattern.test(value);
}

export { handleCopy, formatNumber, getOrdinalPosition, formatTime, convertToString, isGuid };
